"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var ArrowLeft = function ArrowLeft(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/nav/arrow_left-arrow-left" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-arrow-left" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.25216138,12.9385269 L12.7602031,19.4465686 C12.9554652,19.6418308 12.9554652,19.9584133 12.7602031,20.1536754 L12.0958081,20.8180704 C11.900546,21.0133325 11.5839635,21.0133325 11.3887014,20.8180704 L3.51324437,12.9426134 C3.19134046,12.6186662 3.03038851,12.2947191 3.03038851,11.970772 C3.03038851,11.6468248 3.19134046,11.3228777 3.51324437,10.9989306 L11.3887014,3.12347359 C11.5839635,2.92821144 11.900546,2.92821144 12.0958081,3.12347359 L12.7602031,3.78786854 C12.9554652,3.98313069 12.9554652,4.29971317 12.7602031,4.49497532 L6.25624783,10.9989306 L20.4696115,10.9989306 C20.7457539,10.9989306 20.9696115,11.2227882 20.9696115,11.4989306 L20.9696115,12.4385269 C20.9696115,12.7146693 20.7457539,12.9385269 20.4696115,12.9385269 L6.25216138,12.9385269 Z",
    fill: "inherit",
    id: "path-1-arrow-left" + unique,
    transform: "translate(12.000000, 11.970772) scale(1, -1) translate(-12.000000, -11.970772) "
  }))));
};

ArrowLeft.propTypes = propTypes;
var _default = ArrowLeft;
exports["default"] = _default;